import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  ContentArea,
  ErrorSuccessModal,
  Loader,
} from "../../../components/commons";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import { SideMenus, Modules } from "../../../components/UserManagement";
import {
  createUserGroupAction,
  getAllMenuListAction,
  getSingleUserGroupDetailsAction,
  resetEditUserGroupData,
  resetGroupMenu,
  resetGroupName,
  resetModulesList,
  resetOthersList,
  resetSideMenuList,
  resetUserManagementError,
  resetUserManagementSuccess,
  updateUserGroupAction,
} from "../../../redux/userManagement";
import {
  EditUserGroupDataType,
  MenuType,
} from "../../../redux/userManagement/userManagementTypes";
import {
  CreateUserGroupType,
  GetSingleUserGroupDetailsType,
  UpdateUserGroupType,
} from "../../../commonTypes/userManagementTypes";
import { resetSession } from "../../../redux/auth";
import { useParams } from "react-router-dom";
import OthersMenu from "../../../components/UserManagement/OthersMenu";

type AppProps = {
  history: any;
  success: number | null;
  error: string | null;
  fetching: boolean;
  statusCode: number | null;
  token: string | null;
  sideMenuList: [] | MenuType[];
  othersList: [] | MenuType[];
  moduleList: [] | MenuType[];
  group_menu: [] | number[];
  group_name: string;
  editUserGroupData: EditUserGroupDataType;
  dispatchResetUserManagementError: () => void;
  dispatchResetUserManagementSuccess: () => void;
  dispatchResetSideMenuList: () => void;
  dispatchResetModulesList: () => void;
  dispatchGetAllMenuListAction: (token: string) => void;
  dispatchCreateUserGroupAction: (data: CreateUserGroupType) => void;
  dispatchResetSession: () => void;
  dispatchGetSingleUserGroupDetailsAction: (
    data: GetSingleUserGroupDetailsType
  ) => void;
  dispatchUpdateUserGroupAction: (data: UpdateUserGroupType) => void;
  dispatchResetEditUserGroupData: () => void;
  dispatchResetGroupNameAction: () => void;
  dispatchResetGroupMenuAction: () => void;
  dispatchResetOthersList: () => void;
};

const AddEditUserGroup = ({
  success,
  fetching,
  history,
  error,
  statusCode,
  token,
  sideMenuList,
  othersList,
  moduleList,
  group_menu,
  group_name,
  dispatchGetAllMenuListAction,
  dispatchResetModulesList,
  dispatchResetSideMenuList,
  dispatchResetUserManagementError,
  editUserGroupData,
  dispatchResetUserManagementSuccess,
  dispatchCreateUserGroupAction,
  dispatchUpdateUserGroupAction,
  dispatchGetSingleUserGroupDetailsAction,
  dispatchResetEditUserGroupData,
  dispatchResetGroupMenuAction,
  dispatchResetGroupNameAction,
  dispatchResetSession,
  dispatchResetOthersList,
}: AppProps) => {
  const [userGroupName, setUserGroupName] = useState<string>("");
  const [selectedMenus, setSelectedMenus] = useState<number[] | []>([]);
  const [isAllSideMenuCheck, setIsAllSideMenuCheck] = useState<boolean>(false);
  const [userGroupNameError, setUserGroupNameError] = useState<string>("");
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const { group_id }: any = useParams();

  useEffect(() => {
    dispatchResetGroupMenuAction();
    dispatchResetGroupNameAction();
    setSelectedMenus([]);
    setUserGroupName("");
    dispatchResetModulesList();
    dispatchResetOthersList();
    dispatchResetSideMenuList();
    dispatchResetUserManagementError();
    dispatchResetUserManagementSuccess();
    if (token) {
      dispatchGetAllMenuListAction(token);
    }
  }, []);

  useEffect(() => {
    if (group_id && token) {
      setIsEdit(true);
      // dispatchResetGroupMenuAction();
      // dispatchResetGroupNameAction();
      dispatchGetSingleUserGroupDetailsAction({ group_id: group_id, token });
    }
  }, [group_id]);

  useEffect(() => {
    if (group_name?.length > 0 && group_menu?.length > 0 && isEdit) {
      setSelectedMenus(group_menu);
      setUserGroupName(group_name);
    }
  }, [group_menu, group_name]);

  const handleSelectMenus = (menuId: number) => {
    let oldSelectedSideMenu = [...selectedMenus];
    let finalSideMenuArray = [];

    if (oldSelectedSideMenu?.includes(menuId)) {
      finalSideMenuArray = oldSelectedSideMenu?.filter(
        (id: number) => id !== menuId
      );
    } else {
      finalSideMenuArray = [...oldSelectedSideMenu, menuId];
    }

    setSelectedMenus(finalSideMenuArray);
  };

  /* const handleSelectAllSideMenus = () => {
    setIsAllSideMenuCheck(!isAllSideMenuCheck);
    setSelectedSideMenu([])
    if (isAllSideMenuCheck) {
      setSelectedSideMenu([]);
    }
  } */

  const handleSubmitData = () => {
    if (!userGroupName.length) {
      setUserGroupNameError("User group name is required !");
    } else {
      if (group_id && isEdit) {
        setUserGroupNameError("");
        let finalData: UpdateUserGroupType = {
          token,
          group_name: userGroupName,
          group_id: group_id,
          menu_map_id: selectedMenus,
        };
        dispatchUpdateUserGroupAction(finalData);
        // setIsEdit(false);
        dispatchResetGroupMenuAction();
        dispatchResetGroupNameAction();
      } else {
        setUserGroupNameError("");
        if (token) {
          let finalData = {
            token,
            group_name: userGroupName,
            menu_map_id: selectedMenus,
          };

          dispatchCreateUserGroupAction(finalData);
        }
      }
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetUserManagementError();
            }}
          />
        );
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={`User Group ${
            !!isEdit ? "Updated" : "Created"
          } Successfully!`}
          buttonText="OK"
          onPress={() => {
            setSelectedMenus([]);
            setUserGroupName("");
            dispatchResetUserManagementSuccess();
            history?.goBack();
          }}
          statusCode={statusCode}
        />
      );
    }

    return false;
  };

  return (
    <>
      <CommonHeader title={`${!isEdit ? "Create" : "Update"} User Group`} />
      <ContentArea>
        <div style={{ width: "40%" }}>
          <form>
            <div className="form-group mt-3">
              <div>
                <label
                  htmlFor="User Group"
                  className={userGroupName ? "active" : ""}
                >
                  Enter User Group Name*
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    !!userGroupNameError ? "error-border" : null
                  }`}
                  name="userGroup"
                  value={userGroupName}
                  onChange={(e) => setUserGroupName(e.target.value)}
                />
                {!!userGroupNameError && (
                  <small className="text-danger">{userGroupNameError}</small>
                )}
              </div>
            </div>
          </form>
        </div>
        <h2 className="mb-2 font-weight-bolder">Side Menu:</h2>
        <div
          style={{
            borderBottom: "1px solid #dd4433",
            width: "15%",
            marginBottom: "20px",
          }}
        ></div>
        <SideMenus
          sideMenus={sideMenuList}
          selectedMenus={selectedMenus}
          handleSelectMenus={handleSelectMenus}
        />
        <h2 className="mb-2 font-weight-bolder">Modules:</h2>
        <div
          style={{
            borderBottom: "1px solid #dd4433",
            width: "15%",
            marginBottom: "20px",
          }}
        ></div>
        <Modules
          moduleList={moduleList}
          selectedMenus={selectedMenus}
          handleSelectMenus={handleSelectMenus}
        />
        <h2 className="mb-2 font-weight-bolder">Others:</h2>
        <div
          style={{
            borderBottom: "1px solid #dd4433",
            width: "15%",
            marginBottom: "20px",
          }}
        ></div>
        <OthersMenu
          moduleList={othersList}
          selectedMenus={selectedMenus}
          handleSelectMenus={handleSelectMenus}
        />
        <div className="row mt-3">
          <div className="col-md-12 text-right">
            <button
              className="mr-3 btn btn-outline-default"
              onClick={() => history?.goBack()}
            >
              Cancel
            </button>
            <button className="btn btn-primary" onClick={handleSubmitData}>
              {isEdit ? "Update" : "Create"} User Group
            </button>
          </div>
        </div>
      </ContentArea>
      {handleErrorModal()}
      {fetching && <Loader />}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.userManagement.fetching,
  error: state.userManagement.error,
  success: state.userManagement.success,
  sideMenuList: state.userManagement.sideMenuList,
  moduleList: state.userManagement.moduleList,
  othersList: state.userManagement.othersList,
  statusCode: state.userManagement.statusCode,
  editUserGroupData: state.userManagement.editUserGroupData,
  group_menu: state.userManagement.group_menu,
  group_name: state.userManagement.group_name,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetUserManagementError: () => dispatch(resetUserManagementError()),
  dispatchResetUserManagementSuccess: () =>
    dispatch(resetUserManagementSuccess()),
  dispatchResetSideMenuList: () => dispatch(resetSideMenuList()),
  dispatchResetModulesList: () => dispatch(resetModulesList()),
  dispatchResetOthersList: () => dispatch(resetOthersList()),
  dispatchGetAllMenuListAction: (token: string) =>
    dispatch(getAllMenuListAction(token)),
  dispatchCreateUserGroupAction: (data: CreateUserGroupType) =>
    dispatch(createUserGroupAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetSingleUserGroupDetailsAction: (
    data: GetSingleUserGroupDetailsType
  ) => dispatch(getSingleUserGroupDetailsAction(data)),
  dispatchUpdateUserGroupAction: (data: UpdateUserGroupType) =>
    dispatch(updateUserGroupAction(data)),
  dispatchResetEditUserGroupData: () => dispatch(resetEditUserGroupData()),
  dispatchResetGroupNameAction: () => dispatch(resetGroupName()),
  dispatchResetGroupMenuAction: () => dispatch(resetGroupMenu()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddEditUserGroup);
